import { render, staticRenderFns } from "./fxList.vue?vue&type=template&id=db58af3a&scoped=true&"
import script from "./fxList.vue?vue&type=script&lang=js&"
export * from "./fxList.vue?vue&type=script&lang=js&"
import style0 from "./fxList.vue?vue&type=style&index=0&id=db58af3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db58af3a",
  null
  
)

export default component.exports